import React from 'react';
export var UPDATE_SORT_RAITING = 'UPDATE_SORT_RAITING';
export function updateSortRaiting(sorting) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_SORT_RAITING,
            payload: sorting
        });
    };
}
//# sourceMappingURL=sortRaitingAction.js.mapimport React from 'react';
export var UPDATE_SORT_RAITING = 'UPDATE_SORT_RAITING';
export function updateSortRaiting(sorting) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_SORT_RAITING,
            payload: sorting
        });
    };
}
//# sourceMappingURL=sortRaitingAction.js.map